import {defineSlotRecipe} from '@chakra-ui/react3'

export default defineSlotRecipe({
    slots: ['button', 'link'],
    base: {
        button: {
            size: 'lg'
        },
        link: {
            width: 'max-content'
        }
    },
    variants: {
        variant: {
            primary: {
                button: {
                    variant: 'primaryFilled'
                }
            },
            secondary: {
                button: {
                    variant: 'secondaryOutline'
                }
            },
            secondaryOnMedia: {
                button: {
                    variant: 'secondaryOnMedia'
                }
            },
            // Same as secondaryGhost with on-media text color for dark backgrounds
            secondaryGhostOnMedia: {
                button: {
                    variant: 'secondaryGhostOnMedia'
                }
            },
            text: {
                link: {
                    variant: 'secondary',
                    underline: true
                }
            },
            textSecondaryGhostOnMedia: {
                link: {
                    variant: 'secondaryGhostOnMedia',
                    underline: true
                }
            },
            secondaryGhost: {
                button: {
                    variant: 'secondaryGhost'
                }
            },
            textSecondaryGhost: {
                link: {
                    variant: 'secondaryGhost',
                    underline: true
                }
            }
        }
    }
})
